import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBrZH9uElg5ZLoAYdAyH7IBQKB5RfqCbJc",
  authDomain: "it21-web.firebaseapp.com",
  projectId: "it21-web",
  storageBucket: "it21-web.firebasestorage.app",
  messagingSenderId: "293975589658",
  appId: "1:293975589658:web:f99c499bb757cf76e422a3",
  measurementId: "G-282NN77H4G"
};


const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export { app, auth };